<template>
    <div class="w-full grid lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-4 items-end border-b-2 border-[#4C535966]">
      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Name (as passport)")}}<span class="ml-2 text-primary">*</span></label>
        <input type="text" v-model="pax.name" @change="update" :class="{'error': errors.name, 'readonly-field': isDisabled}"
          :disabled="isDisabled" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3" />
      </div>

      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Last Name (As Passport)")}}<span class="ml-2 text-primary">*</span></label>
        <input type="text" v-model="pax.lastName" @change="update" :class="{'error': errors.lastName, 'readonly-field': isDisabled}"
          :disabled="isDisabled" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3" />
      </div>

      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Date of birth")}}<span class="ml-2 text-primary">*</span></label>

        <div class="relative w-full">
          <Datepicker :teleport="true" :value="viewDate(pax.DOB)" @selected="updateDOB" @input="updateDOB" 
            :class="{'error': errors.DOB, 'readonly-field': isDisabled}" :disabled="isDisabled"
            class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-1"></Datepicker>
        </div>
      </div>

      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Gender")}}</label>

        <select id="gender" v-model="pax.gender" @change="update" :disabled="isDisabled"
          class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3"
          :class="{'readonly-field': isDisabled}">
          <option :selected="pax.gender == 'MALE'" value="MALE">{{tr("Male")}}</option>
          <option :selected="pax.gender == 'FEMALE'" value="FEMALE">{{tr("Female")}}</option>
        </select>
      </div>

      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Nationality")}}<span class="ml-2 text-primary">*</span></label>
        <select id="countries" v-model="pax.nationality" :class="{'error': errors.nationality, 'readonly-field': isDisabled}" 
          @change="update" :disabled="isDisabled"
          class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3">
          <option v-for="(c, i) of countriesJSON" :key="i" :value="c.alpha2" :selected="c.alpha2 == pax.nationality">{{ c.name }}</option>
        </select>
      </div>


      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Valid Passport Number")}}<span class="ml-2 text-primary">*</span></label>
        <input v-model="pax.passport" @change="update" type="text" :class="{'error': errors.passport, 'readonly-field': isDisabled}"
          :disabled="isDisabled" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3" />
      </div>
      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Address")}}</label>
        <input v-model="pax.address" @change="update" type="text" :disabled="isDisabled"
          :class="{'readonly-field': isDisabled}" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3" />
      </div>
      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Email")}}<span class="ml-2 text-primary">*</span></label>
        <input v-model="pax.email" @change="update" type="email" :class="{'error': errors.email, 'readonly-field': isDisabled}"
          :disabled="isDisabled" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3" />
      </div>
      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Cellphone")}}<span class="ml-2 text-primary">*</span></label>
        <input v-model="pax.mobile" @change="update" type="text" :class="{'error': errors.mobile, 'readonly-field': isDisabled}"
          :disabled="isDisabled" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3" />
      </div>
      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Main reason of your trip")}}</label>
        
        <select id="hobbies" v-model="pax.tripReason" @change="update" :disabled="isDisabled"
          :class="{'readonly-field': isDisabled}" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3">
          <option v-for="(c, i) of tripReasons" :key="i" :selected="c == pax.tripReason">{{ c }}</option>
        </select>
      </div>

      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Allergies")}}</label>
        <input v-model="pax.allergies" @change="update" type="text" :disabled="isDisabled" maxlength="60"
          :class="{'readonly-field': isDisabled}" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3" :placeholder="tr('If yes, which?')" />
      </div>
      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Medical Conditions")}}</label>
        <input v-model="pax.medicalConditions" @change="update" type="text" :disabled="isDisabled" maxlength="60"
          :class="{'readonly-field': isDisabled}" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3" :placeholder="tr('If yes, which?')" />
      </div>
      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Medication")}}</label>
        <input v-model="pax.medication" @change="update" type="text" :disabled="isDisabled" maxlength="60"
          :class="{'readonly-field': isDisabled}" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3" :placeholder="tr('If yes, which?')" />
      </div>
      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Food Restriction")}}</label>
        <input v-model="pax.foodRestriction" @change="update" type="text" :disabled="isDisabled" maxlength="60"
          :class="{'readonly-field': isDisabled}" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3" :placeholder="tr('Celiac, vegetarian, etc.')" />
      </div>
      <div class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">{{tr("Hobbies")}}</label>
        <select id="hobbies" v-model="pax.hobbies" @change="update" :disabled="isDisabled"
          :class="{'readonly-field': isDisabled}" class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3">
          <option v-for="(c, i) of hobbies" :key="i" :selected="c == pax.hobbies">{{ c }}</option>
        </select>
      </div>

      <div class="mb-5 sm:col-span-2" v-if="!isDisabled">
        <div class="inline-block">
          <label :for="`file-upload-${paxNumber}`" class="cursor-pointer pb-2 border-b border-black uppercase font-semibold text-sm flex w-auto">
            <svg width="26" height="12" viewBox="0 0 26 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5303 0.96967C13.2374 0.676777 12.7626 0.676777 12.4697 0.96967L7.6967 5.74264C7.40381 6.03553 7.40381 6.51041 7.6967 6.8033C7.98959 7.09619 8.46447 7.09619 8.75736 6.8033L13 2.56066L17.2426 6.8033C17.5355 7.09619 18.0104 7.09619 18.3033 6.8033C18.5962 6.51041 18.5962 6.03553 18.3033 5.74264L13.5303 0.96967ZM13.75 11.5L13.75 1.5L12.25 1.5L12.25 11.5L13.75 11.5Z" fill="#1F2326"/>
            </svg>
            {{tr("Please upload an image of your Passport")}}
          </label>
          <input :id="`file-upload-${paxNumber}`" class="hidden" type="file" @change="uploadPassport($event)" multiple />
          <div v-for="(file, i) of pax.files" :key="i">
            {{file.name}}
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs3-datepicker';
let countriesJSON = require(`@/assets/world.json`);
var moment = require('moment');
export default {
  name: 'BookingFromPax',
  data() {
    return {
      countriesJSON: countriesJSON,
      pax: {},
      hobbies: [
        this.tr('Historical'),
        this.tr('Cultural'),
        this.tr('Wine'),
        this.tr('Trekking'),
        this.tr('Fishing'),
        this.tr('Tango'),
        this.tr('Geography'),
        this.tr('Others'),
      ],
      tripReasons: [
        this.tr('Birthday / Anniversary'),
        this.tr('Honeymoon'),
        this.tr('Tourism'),
        this.tr('Adventure trips'),
        this.tr('Others'),
      ],
      limitSize: 10000000,
    }
  },
  components: {
    Datepicker
  },
  mounted () {
    this.pax = Object.assign({}, this.passenger);
  },
  props: {
    passenger: Object,
    errors: Object,
    paxNumber: Number,
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    update () {
      if (!this.isDisabled) {
        this.$emit('updateData', this.pax, this.paxNumber);
      }
    },
    updateDOB (a) {
      if (!this.isDisabled) {
        this.pax.DOB = moment.utc(a).format('YYYY-MM-DD');
        this.update();
      }
    },
    checkFileSize (file) {
      if (file.size > this.limitSize) {
        return false;
      }
      return true;
    },
    uploadPassport (event) {
      if (this.isDisabled) return;
      
      let input = event.target;
      if (input.files) {
        let err;
        for (let j = 0; j < input.files.length; j++) {
          if (!this.checkFileSize(input.files[j])) {
            err = true;
          }
        }
        if (err) {
          input.files = null;
          alert(`Maximum allowed file size ${this.limitSize / 1000000} Mb`);
        } else {
          this.pax.files = input.files;
          this.update();
        }
      }
    },
    tr (key) {
      return this.$root.tr(key);
    },
    viewDate(date) {
      if (date) {
        return new Date(date + 'T00:00:00');
      }
      return null;
    }
  }
}
</script>

<style scoped>
a {
  cursor: pointer;
}

.error {
  border: 2px solid red;
}

.readonly-field {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
  opacity: 0.8;
}

</style>